






















































































import { Component, Vue } from 'vue-property-decorator';
import { ObjectFactory } from '../../config/objectFactory';
import { AddLocationRequest } from '../../types/request';
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';
import { MapUtils } from '../../util/mapUtils';
import { MedTransGoConstants } from '../../util/constants';
import { ToastEvent } from '../../types/event';
import { CommonUtils } from '../../util/commonUtils';
import { EventBus } from '../../main';
import { MemberProfile } from '@/types/response';
declare var google: any;

@Component({
    mixins: [validationMixin],
    data() {
        return {
            locationName: '',
            insuranceCompany: '',
            adjusterEmail: '',
            address: {
                fullAddress: '',
                state: '',
                city: '',
                landmark: '',
                zip: '',
            },
            companyCode: '',
            department: '',
            locationCode: '',
            account: '',
        };
    },
    validations() {
        const memberProfile = ObjectFactory.getCacheService().getMemberInfo();
        const rules = {
            locationName: {
            required,
        },
        insuranceCompany:  {
                    required,
                },
                adjusterEmail:  {
                    required,
                    email,
                },
        address: {
            fullAddress: {
                required,
            },
            city: {
                required,
            },
            state: {
                required,
            },
            zip: {
                required,
            },
        },
        };
        if (!memberProfile.isCaseManager) {
            delete rules.adjusterEmail;
            delete rules.insuranceCompany;
        }
        return rules;
    },
})
export default class AddLocationModal extends Vue {
    private locationGoogleAddress: any;
    private show = true;
    private memberProfile: MemberProfile = null as any;
    public mounted() {
        this.getGoogleAddress();
        this.memberProfile = ObjectFactory.getCacheService().getMemberInfo();
    }

    /**
     * @author <Aniket.P>
     * @description - google places
     * @param req {Request} - Express Request
     * @param res {Response} - Express Response - google places suggession
     * @returns google places suggession
     * @throws InvalidRequestException if network error
     */
    private async getGoogleAddress() {
        this.$root.$on('bv::modal::shown', (bvEvent: any, modalId: any) => {
            this.locationGoogleAddress = new google.maps.places.Autocomplete(
                document.getElementById('locationAddress'), {
                types: ['geocode'],
            },
            );
            this.locationGoogleAddress.addListener('place_changed', () => {
                this.$data.address = MapUtils.parseGoogleAddress(this.locationGoogleAddress);
            });
        });
    }


    /**
     * @author <Amol.D>
     * @description - add new location
     * @param req {Request} - calls add location API
     * @param res {Response} - Express Response - success result
     * @returns member list
     * @throws InvalidRequestException if location already exists
     */
    private async addLocation() {
        const addLocationRequest: AddLocationRequest = {
            adjusterEmail: this.$data.adjusterEmail,
            insuranceCompany: this.$data.insuranceCompany,
            locationAddress: this.$data.address,
            locationName: this.$data.locationName,
            companyCode: this.$data.companyCode,
            department: this.$data.department,
            locationCode: this.$data.locationCode,
            account: this.$data.account,
        };
        const response = await ObjectFactory.getOrganizationService().addLocation(this.$store.state.serverUrl,
        addLocationRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: CommonUtils.translateMessageCode('MSG_ADD_LOCATION'),
                title: 'Success!',
                timeout: 2000,
                varient: 'success',
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.$emit('success');
            this.close();
        } else {
            CommonUtils.showError(response);
        }
    }
    private close() {
        if (this.$route.path === `${MedTransGoConstants.URL_SETTING}/${MedTransGoConstants.URL_ADD_LOCATION}`) {
            this.$router.push({
                name: MedTransGoConstants.VIEW_SETTING_NAME,
            });
        } else {
            this.$emit('close');
        }
    }
}
